// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16 1H8V5H16V1Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3 3H6V7H18V3H21V23H3V3ZM15 13V11H9V13H15ZM15 17V15H9V17H15Z"}}]};

const TaskFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'task-filled',
    ref,
    icon: element,
  },
));

TaskFilledIcon.displayName = 'TaskFilledIcon';

export default TaskFilledIcon;
